<i18n>
  {
    "en": {
      "occupation": "occupation"
    },
    "es": {
      "occupation": "Ocupación"
    }
  }
</i18n>

<script>
import Component from 'vue-class-component';
import { MapActions } from '@core/helpers/decorators';
import KpiComponent from './KpiComponent.vue';
import * as KPITypes from '../constants';

@Component
@MapActions(['calculateOccupationKPI'])
export default class OccupationKpi extends KpiComponent {
  unit = ''

  unitPosition = 'right'

  isCurrencyUnit = false

  icon = 'fas fa-users'

  iconSize = 20;

  kpiType = KPITypes.OCCUPATION

  get title() {
    return this.$t('occupation');
  }

  async calculate() {
    await this.calculateOccupationKPI({ pointOfSaleGuid: this.$route.params.pointOfSaleGuid, isManaged: this.isManaged });
    this.loadKPIModel();
  }
}
</script>
